import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FooterService {
    constructor(private http: HttpClient) { }

    getFooterService() {
        return this.http.get<any[]>(`${environment.apiUrl}footer`);
    }    
	
     
}